export const createStyles = (theme: any) => {
  const isDark = theme.palette.mode === 'dark';
  return {
    modalWrapper: {
      width: '560px',
      maxWidth: 'calc(100vw - 2rem)',
      minWidth: 0,
      minHeight: '293px',
      maxHeight: '90vh',
      bgcolor: theme.palette.background.paper,
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
      p: '1rem',
      borderRadius: '0.5rem',
      boxSizing: 'border-box',
      overflow: 'hidden',
    },
    mobileEditorWrapper: {
      width: '100%',
      flex: '1',
    },
    modalHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '1rem',
    },
    closeButton: {
      color: theme?.palette?.text?.secondary,
      flexShrink: 0,
      mr: '-0.25rem',
    },
    footer: {
      display: 'flex',
      gap: '0.75rem',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      alignItems: 'center',
      minHeight: '42px',
    },
    footerExtra: {
      marginRight: 'auto',
      display: 'flex',
      alignItems: 'center',
      gap: '0.75rem',
    },
    editorWrapper: {
      flex: 1,
      minWidth: 0,
      minHeight: 0,
      width: '100%',
      maxWidth: '100%',
      boxSizing: 'border-box',
      overflowY: 'auto',
      overflowX: 'hidden',
      '& [data-testid="block-menu-toggle"]': {
        color: isDark ? '#FFFFFF8F !important' : '#231F298F !important',
      },
      '& p[data-slate-node="element"]': {
        minHeight: { xs: '50px', md: 'auto' },
      },
      '& [data-testid="block-toolbar"]': {
        top: '-10px',
      },
    },
    buttonSx: {
      width: { xs: 'auto', sm: '75px' },
      height: '42px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: theme.palette?.primary?.dark,
        borderColor: theme.palette?.primary?.dark,
      },
      '&.MuiButton-outlinedPrimary:hover': {
        backgroundColor: 'transparent',
        borderColor: theme.palette?.primary?.main,
      },
    },
    visuallyHidden: {
      display: 'none',
    },
  };
};
